<template>
  <div class="cell large-12 xxlarge-6">
    <div class="card">
      <div class="grid-x card-header">
        <div class="cell auto">
          <router-link :to="{ name: 'DashboardPageUferdigeObjekt'}">
            <h3 class="icon-heading small">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-object"></use></svg></span> Uferdige objekter
              <span v-if="total !== null" class="opacity-60">({{total}})</span>
            </h3>
          </router-link>
        </div>

        <!-- Brukerlist dropdown -->
        <div class="cell shrink" v-if="this.canSelectBruker">
          <div class="select-container small has-popover" :class="{'popover-active': brukerPopoverActive}" @click="toggleBrukerPopover()">
            <a class="button-select" href="javascript:;">
              <span class="title"><span>{{selectedBruker}}</span></span>
              <!-- <span class="label gray small">495</span>  -->
              <span class="glyph"><svg viewBox="0 0 6 12"><use xlink:href="/static/sprites.svg#glyph-input-select-tiny"></use></svg></span>
            </a>

            <span class="popover select-dropdown-popover align-x-right align-y-bottom large">
              <div class="custom-scrollbar">
                <ul>
                  <li v-for="item in brukerList" :key="item.key" :class="{'active': item.key === selectedBrukerId}">
                    <a href="javascript:;" @click="setBruker(item.key)"><span>{{item.val || item.key}}</span><!-- <span class="label gray small">495</span>--></a>
                  </li>
                </ul>
              </div>
            </span>
          </div>
        </div>
        <!-- Brukerlist dropdown -->
      </div>

      <table-uferdige-objekt v-on:tableLoaded="tableLoaded" :limit="6" :large="false" :brukerId="selectedBrukerId" />
    </div>
  </div>
</template>

<script>
import TableUferdigeObjekt from './TableUferdigeObjekt'

export default {
  name: 'WidgetUferdigeObjekt',
  components: {
    TableUferdigeObjekt
  },
  props: {
    brukerList: {
      type: Array,
      required: false,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      brukerPopoverActive: false,
      selectedBrukerId: null,
      total: null
    }
  },
  created () {
    const vm = this

    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.brukerPopoverActive = false
      }
    })

    if (this.canSelectBruker) {
      this.selectedBrukerId = localStorage.dbw_uferdige_objekt || null
    } else {
      this.selectedBrukerId = null
    }
  },
  computed: {
    canSelectBruker: function () {
      return this.hasAccess('admin')
    },
    selectedBruker: function () {
      if (this.brukerList && this.brukerList.length) {
        const found = this.brukerList.find(x => x.key === this.selectedBrukerId)

        if (found) {
          return found.val || found.key
        }
      }

      return 'Alle kontraktsansvarlige'
    }
  },
  methods: {
    tableLoaded: function (data) {
      this.total = data.total
    },
    setBruker: function (itemId) {
      this.selectedBrukerId = itemId || null

      if (this.selectedBrukerId) {
        localStorage.dbw_uferdige_objekt = this.selectedBrukerId
      } else {
        localStorage.removeItem('dbw_uferdige_objekt')
      }
    },
    toggleBrukerPopover: function () {
      this.brukerPopoverActive = !this.brukerPopoverActive
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Dashboard/WidgetUferdigeObjekt.vue